"use strict";

(function(){

var self = Fotobook.userQuery = {
    id: null,
    key: "userQueryID",
    showLoggedOutDialog: function(){
        if ($(".loggedOut-dialog").length){
            return;
        }

        Fotobook.dialog.alert(t("photobook-js-loggedOut"), {
            "title": t("photobook-js-loggedOut-title"),
            "dialogClass": "loggedOut-dialog",
        }).then(
            () => window.location.assign("/"),
            () => null
        );
    },
    init: function(){
        var id = $(".userQueryID").attr("content");
        if (id) {
            Fotobook.debug("Meta userQueryID: ", id);
            self.id = id;
            if (localStorage.getItem(self.key) !== id) {
                localStorage.setItem(self.key, id);
            }
            window.addEventListener("storage", self.eventStorageChange, false);
            $(document).on(Fotobook.ajax.EVENT_BEFORE_DONE, self.eventAjaxBeforeDone);
        }
    },

    /**
     * Мониторим изменения в LocalStorage
     *
     * @param e
     */
    eventStorageChange: function(e){
        if (e.key == self.key) {
            if (e.newValue && e.newValue != self.id && Fotobook.store.state.user.id) {
                self.showLoggedOutDialog();
            }
        }
    },

    eventAjaxBeforeDone: function(event, response, status, jqXHR){
        var id = jqXHR.getResponseHeader("Fotobook-userQueryID");
        if (id && id.length && id != self.id) {
            Fotobook.debug("Ajax userQueryID is not equal to saved id: ", id, self.id);
            event.preventDefault();
            self.showLoggedOutDialog();
        }
    },
};

// Отключаем функционал для фрейма с регистрацией, так как основной фрейм и так всё это обрабатывает
if (window.parent == window || !window.parent.Fotobook){
    $(self.init);
}

})();
